import React, { useState, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../Button';
import {
  INITIAL_VALUES,
  VALIDATION_SCHEMA,
} from 'web/components/utils/forgotPasswordUtils';
import TextInput from 'web/components/form-elements/TextInput';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import api from '../../../api/axioPath';
import AlertModal from 'web/components/AlertModal';
import styles from './forgotPassword.module.scss';
import { fetchLanguageContentNew } from 'redux/actions/language';

const ForgotPassword = ({ buttonName }) => {
  let dispatch = useDispatch()
  const [forgotModal, forgoToggleModal] = useState(false);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  useEffect(() => {
    if (languageContentNew?.SignIn_Page) setPageLanguageContents(languageContentNew.SignIn_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  const toggleModal = () => setModal(!modal);

  const forgotHandler = async (props) => {
    let data = {
      email: props.values.email,
    };
    const response = await api.post('/users/forgot-password', data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.data.status === "SUCCESS") {
      forgoToggleModal(!forgotModal)
      setModalContent("Password reset link has been sent to the registered email address.");
      setModalLink('');
      toggleModal();
    } else {
      setModalContent(response.data.message);
      setModalLink('');
      toggleModal();
    }
  };

  return (
    <div className={styles.forgotPasswordContainer}>
      <a onClick={() => forgoToggleModal(!forgotModal)}>{buttonName}</a>
      <Modal
        isOpen={forgotModal}
        toggle={() => forgoToggleModal(!forgotModal)}
        backdrop={'static'}
        centered={true}
        className={styles.forgotPassword}>
        <div className={styles.header}>
          <Button handleClick={() => forgoToggleModal(!forgotModal)}>
            <img src={CloseIcon} className="closeIcon" alt="close-icon" />
          </Button>
          <h3>
            {pageLanguageContents?.Forgot_Popup[0]?.Title}
          </h3>
        </div>
        <ModalBody className={styles.body}>
          <Formik
            initialValues={INITIAL_VALUES}
            validationSchema={VALIDATION_SCHEMA(pageLanguageContents)}
            onSubmit={(values) => { }}>
            {(props) => {
              const { isValid, dirty } = props;
              return (
                <>
                  <Form>
                    <div className={styles.fieldGroup}>
                      <div className={styles.field}>
                        <p className={styles.inputLabel}>
                          {pageLanguageContents?.Forgot_Popup[1]?.Placeholder}<span className="star">*</span>
                        </p>
                        <TextInput
                          name="email"
                          maxLength={100}
                          placeholder={pageLanguageContents?.Forgot_Popup[1]?.Placeholder}
                          showErrorMessages={true}
                        />
                      </div>
                    </div>
                    <div className={styles.footer}>
                      <Button
                        type="app-green-button"
                        handleClick={() => {
                          forgotHandler(props);
                        }}
                        disabled={!(isValid && dirty)}
                      >
                        {pageLanguageContents?.Forgot_Popup[2]?.Button}
                      </Button>
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </ModalBody>
      </Modal>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        content={modalContent}
        link={modalLink}
      />
    </div>
  );
};

export default ForgotPassword;
